export default "<p>add-payment-dialog works!</p>\n"